<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})

const props = defineProps<{
  modelValue?: string
  options: { value: string; label: string }[]
  loading?: boolean
  clearable?: boolean
  placeholder?: string
  wrapperClasses?: string
  inputClasses?: string
}>()

const emit = defineEmits(['update:modelValue'])

const state = reactive({
  selected: props.modelValue
})

watch(
  () => props.modelValue,
  (value) => {
    state.selected = value
  }
)
</script>

<template>
  <div class="tw-relative tw-rounded-lg tw-bg-gray-100" :class="props.wrapperClasses">
    <div v-if="props.loading" class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-pl-4">
      <LoadingIndicator />
    </div>

    <select
      v-model="state.selected"
      class="normalize-style tw-w-full tw-appearance-none tw-bg-transparent tw-py-2 tw-pl-4"
      :class="[props.clearable ? 'tw-pr-16' : 'tw-pr-10', props.inputClasses]"
      v-bind="$attrs"
      @change="() => emit('update:modelValue', state.selected)"
    >
      <option v-if="props.placeholder !== undefined" value="" disabled>
        {{ props.placeholder }}
      </option>

      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>

    <div
      class="tw-pointer-events-none tw-absolute tw-right-0 tw-top-0 tw-flex tw-h-full tw-items-center tw-justify-center tw-pr-2"
    >
      <button
        v-if="props.clearable && state.selected"
        type="button"
        class="normalize-style tw-pointer-events-auto tw-cursor-pointer tw-px-2 tw-py-1 tw-text-sm"
        @click="() => emit('update:modelValue', '')"
      >
        <FontAwesomeIcon icon="xmark" class="tw-text-black/50" />
      </button>

      <button type="button" class="normalize-style tw-px-2 tw-py-1 tw-text-sm">
        <FontAwesomeIcon icon="chevron-down" class="tw-text-black/50" />
      </button>
    </div>
  </div>
</template>
